
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { AppUrl } from '../../common/constants/app-urls';
import { JobAction } from '../constants/keep-basic-data';
import { PostingStatus, PostingAction } from '../constants/posting-basic-data';
import { JobItem } from '../models/job-item.model';
import { JobModif } from '../models/job-modif.model';
import { Job } from '../models/job.model';
import { Posting } from '../models/posting.model';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class KeepService {
    //loggedIn = false;
  constructor(private http: HttpClient) {}

  addNewJob(job: Job): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.keepJobs+"/new", 
        job, 
        httpOptions );
  }

  addNewJobItem(jobItem: JobItem): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.keepJobs+"/items/new", 
        jobItem, 
        httpOptions );
  }
  
  updateJob(job: Job): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepJobs+"/update", 
      job,
      httpOptions );  
  }

  executeJobAction(action: JobAction, job: Job | JobModif): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepJobs+"/action/"+action, 
      job,
      httpOptions );  
  }

  executePostingAction(action: PostingAction, posting: Posting ): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepPostings+"/action/"+action, 
      posting,
      httpOptions );  
  }

  updateJobItem(jobItem: JobItem): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepJobs+"/items/update", 
      jobItem,
      httpOptions );  
  }

  deleteJobItem(jobItemId: number): Observable<any>{ 
      
    return this.http.delete<any>(
      AppUrl.keepJobs+"/items/"+jobItemId, 
      httpOptions );  
  }

  updateJobStatus(jobId: string, status: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepJobs+"/"+jobId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  updatePostingStatus(postingId: number, status: PostingStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepPostings+"/"+postingId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  updateJobItemStatus(jobItemId: string, status: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.keepJobs+"/items/"+jobItemId+"/update-status", 
      {data: status},
      httpOptions );  
  }

  connectJob(jobId: string, appointmentId: string, connect: boolean): Observable<any>{ 
      
    let str: string = connect ? "connect" : "disconnect";

    return this.http.post<any>(
        AppUrl.keepJobs+"/"+jobId+"/"+str, 
        {data: appointmentId},
        httpOptions );
  }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
